import { render } from "./Index.3.vue?vue&type=template&id=d725d17c&ts=true"
import script from "./Index.3.vue?vue&type=script&lang=ts"
export * from "./Index.3.vue?vue&type=script&lang=ts"

import "./Index.3.vue?vue&type=style&index=0&id=d725d17c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__